/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { changeRouteAction } from "actions/changeActiveItemActions";
import { Tab, Button, Icon, Modal, Header } from "semantic-ui-react";
import GeneralConfiguration from "components/login-config/configuration/general/GeneralConfiguration";
import ProtocolConfiguration from "components/login-config/configuration/protocol/ProtocolConfiguration";
import AnalyzerDPConfiguration from "components/login-config/configuration/analyzer-dn/AnalyzerDPConfiguration";
import Report from "components/login-config/configuration/report/Report";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

import EthernetConfig from "components/login-config/configuration/general/EthernetConfig";
import WLANConfig from "components/login-config/configuration/general/WLANConfig";
import TsExpertConfig from "./general/TsExpertConfig";
import ChangeLogin from "./general/ChangeLogin";
import EditTags from "./protocol/EditTags";
import Diagnostic from "./protocol/Diagnostic";

const UtilsInstance = new Utils();

class Configuration extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isRestartSystemModalOpen: false
    };
  }

  logOut = () => {
    sessionStorage.removeItem("auth");
    this.props.history.push({ pathname: "/login-handler" });
  }

  showRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: true });
  hideRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: false });

  handleRestartSystemModalPositiveClick = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "restartSystem_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.RESTART_SYSTEM_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.RESTART_SYSTEM_FAILURE + Strings.REASON + error);
      })
      .finally(this.hideRestartSystemModal);
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  getCurrentComponent = (route) => {
    switch (route) {
      case "general":
        return <GeneralConfiguration />;
      case "protocol":
        return <ProtocolConfiguration />;
      case "analyzer-dn":
        return <AnalyzerDPConfiguration />;
      case "ethernet-config":
        return <EthernetConfig />;
      case "wlan-config":
        return <WLANConfig />;
      case "ts-expert-config":
        return <TsExpertConfig />;
      case "change-login":
        return <ChangeLogin />;
      case "tags":
        return <EditTags />;
      case "diagnostic":
        return <Diagnostic />;
      // case "segment-devices":
      //   return <SegmentDevices />;
      default:
        break;
    }
  }

  getButtonDisplay = (currComponent) => {
    if (currComponent === "general" || currComponent === "protocol" || currComponent === "analyzer-dn") {
      return { display: "none" };
    }
    else {
      return { display: "block", marginBottom: "1vh" };
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
  }

  componentWillUnmount() {
    sessionStorage.removeItem("auth");
    this.props.onChangeRoute("general", "protocol", "analyzer-dn");
  }

  render() {
    const panes = [
      {
        menuItem: { key: "gen", content: Strings.GENERAL },
        render: () => <Tab.Pane>
          <Button
            style={this.getButtonDisplay(this.props.currGenConfigComponent)}
            circular
            icon="arrow left"
            onClick={() => {
              this.props.onChangeRoute(
                "general",
                this.props.currProtConfigComponent,
                this.props.currAnDPConfigComponent
              );
            }}
          />
          {this.getCurrentComponent(this.props.currGenConfigComponent)}
        </Tab.Pane>
      },
      {
        menuItem: { key: "mon", content: Strings.MONITORING },
        render: () => <Tab.Pane>
          <Button
            style={this.getButtonDisplay(this.props.currProtConfigComponent)}
            circular
            icon="arrow left"
            onClick={() => {
              this.props.onChangeRoute(
                this.props.currGenConfigComponent,
                "protocol",
                this.props.currAnDPConfigComponent
              );
            }}
          />
          {this.getCurrentComponent(this.props.currProtConfigComponent)}
        </Tab.Pane>
      },
      {
        menuItem: { key: "dp", content: Strings.PHYS_MEDIUM },
        render: () => <Tab.Pane>
          <Button
            style={this.getButtonDisplay(this.props.currAnDPConfigComponent)}
            circular
            icon="arrow left"
            onClick={() => {
              this.props.onChangeRoute(
                this.props.currGenConfigComponent,
                this.props.currProtConfigComponent,
                "analyzer-dn"
              );
            }}
          />
          {this.getCurrentComponent(this.props.currAnDPConfigComponent)}
        </Tab.Pane>
      },
      {
        menuItem: { key: "rep", content: Strings.REPORT },
        render: () => <Tab.Pane> <Report /> </Tab.Pane>
      },
    ];

    return (
      <div style={divStyle}>
        <div style={logoutButtonContainer}>
          <Button
            icon
            style={logoutButtonStyle}
            color="red"
            onClick={this.showRestartSystemModal}>
            <Icon name='power off' />
            {Strings.RESTART_SYSTEM_PROTOCOL}
          </Button>
          <Button
            style={logoutButtonStyle}
            color="grey"
            onClick={this.logOut}>
            Logout
          </Button>
        </div>

        <Tab
          menu={{ fluid: true, vertical: true }}
          grid={{ paneWidth: 14, tabWidth: 2 }}
          menuPosition="left"
          panes={panes}
          renderActiveOnly={true}
        />

        <Modal basic size='small' open={this.state.isRestartSystemModalOpen}>
          <Header icon='history' content={Strings.RESTART_SYSTEM_PROTOCOL} />
          <Modal.Content>
            <p>{Strings.CONFIRM_RESTART_SYSTEM}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='red'
              onClick={this.hideRestartSystemModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button
              color='green'
              onClick={this.handleRestartSystemModalPositiveClick}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const mapActionsToProps = {
  onChangeRoute: changeRouteAction,
};

const mapStateToProps = state => ({
  currGenConfigComponent: state.configRoutes.currGenConfigComponent,
  currProtConfigComponent: state.configRoutes.currProtConfigComponent,
  currAnDPConfigComponent: state.configRoutes.currAnDPConfigComponent
});

const divStyle = {
  margin: "2vh 2vw",
  textAlign: "center"
};

const logoutButtonContainer = {
  textAlign: "right"
};

const logoutButtonStyle = {
  marginBottom: "1em"
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(Configuration));
